import { type FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Radio } from "lucide-react";

import { ApiError } from "../api";
import { useAuth } from "../auth";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [shopSlug, setShopSlug] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await login({ shopSlug: shopSlug.trim(), email: email.trim(), password });
      nav("/", { replace: true });
    } catch (e2) {
      setErr(e2 instanceof ApiError ? e2.message : "Sign-in failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-screen">
      <form className="auth-card" onSubmit={submit}>
        <div className="auth-brand">
          <Radio size={22} className="brand-icon" />
          <span>
            VendorIQ <b>Operations</b>
          </span>
        </div>
        <p className="auth-sub">Sign in to your dispatch console.</p>
        <label>
          Store
          <input
            value={shopSlug}
            onChange={(e) => setShopSlug(e.target.value)}
            placeholder="your-store"
            autoComplete="organization"
            required
          />
        </label>
        <label>
          Email
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
          />
        </label>
        <label>
          Password
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>
        {err && <p className="err">{err}</p>}
        <button type="submit" className="primary" disabled={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
        <p className="auth-hint">
          <Link to="/forgot-password">Forgot your password?</Link>
        </p>
        <p className="auth-hint">
          Store owners open the console from the VendorIQ admin — no password needed.
        </p>
      </form>
    </div>
  );
}
